import React, { isValidElement } from 'react'
import { Check as CheckIcon } from 'react-feather'
import PropTypes from 'prop-types'
import {
  Box,
  Button,
  Dialog,
  Typography,
  CircularProgress,
} from '@material-ui/core'
import clsx from 'clsx'

import useStyles from './styles'
import theme from 'theme'

const ConfirmationDialog = ({
  actionAcceptButton,
  disableBackdropClick = false,
  hiddenIcon = false,
  open,
  setOpen,
  text,
  textButton = 'Confirmo',
  textButtonCancel = 'Voltar',
  variant = 'primary',
  loading = false,
  PaperProps,
  accentColor = null, // cor da borda superior do Paper (ex: theme.palette.error.main)
  paperStyle = {}, // estilos extras no Paper — sobrescreve os do accentColor
  showConfirmBox = false, // exibe box de confirmação com item
  confirmDotColor = null, // cor do dot — dot só aparece se essa prop for passada e showConfirmBox=true
  confirmItem = null, // conteúdo exibido dentro do confirmBox (string ou node)
}) => {
  const classes = useStyles()

  const onClose = (e, reason) => {
    if (reason === 'backdropClick' && !disableBackdropClick) return
    setOpen(false)
  }

  const computedPaperProps = accentColor
    ? {
        ...PaperProps,
        style: {
          border: 'none',
          borderRadius: 12,
          overflow: 'hidden',
          borderTop: `4px solid ${accentColor}`,
          ...paperStyle,
          ...PaperProps?.style,
        },
      }
    : PaperProps

  return (
    <Dialog open={open} onClose={onClose} PaperProps={computedPaperProps}>
      <Box
        m={4}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gridGap={theme.spacing(2)}
        textAlign="center"
      >
        {isValidElement(text) ? (
          text
        ) : (
          <Typography variant="h3">{text}</Typography>
        )}
        {showConfirmBox && (
          <Box className={classes.confirmBox}>
            {confirmDotColor && (
              <Box
                className={classes.confirmDot}
                style={{ backgroundColor: confirmDotColor }}
              />
            )}
            {confirmItem && (
              <Typography variant="body2">{confirmItem}</Typography>
            )}
          </Box>
        )}
      </Box>
      <Box mx={3} mb={2} display="flex" justifyContent="center">
        <Box pr={1}>
          <Button
            disableElevation
            variant="outlined"
            onClick={() => setOpen(false)}
            disabled={loading}
          >
            {textButtonCancel}
          </Button>
        </Box>
        <Button
          disableElevation
          variant="contained"
          color="primary"
          onClick={actionAcceptButton}
          className={clsx({
            [classes.buttonErrorVariant]: variant === 'error',
          })}
          {...(!hiddenIcon && { startIcon: <CheckIcon /> })}
          disabled={loading}
        >
          {/* O texto vai num <span> próprio: o tradutor do navegador troca o nó de texto por um
              <font>, e trocar texto solto pelo spinner fazia o React remover um nó que já não era
              filho do botão (DPO-2977, react#11538). */}
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            <span>{textButton}</span>
          )}
        </Button>
      </Box>
    </Dialog>
  )
}

ConfirmationDialog.propTypes = {
  actionAcceptButton: PropTypes.func.isRequired,
  disableBackdropClick: PropTypes.bool,
  hiddenIcon: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  textButton: PropTypes.string,
  textButtonCancel: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'error']),
  loading: PropTypes.bool,
  accentColor: PropTypes.string,
  paperStyle: PropTypes.object,
  PaperProps: PropTypes.object,
  showConfirmBox: PropTypes.bool,
  confirmDotColor: PropTypes.string,
  confirmItem: PropTypes.node,
}

export default ConfirmationDialog
